// extracted by mini-css-extract-plugin
module.exports = {"note":"ContactForm_note__2Dlla","subNote":"ContactForm_subNote__EH66f","message":"ContactForm_message__L34l7"};